import { Building2, Mail } from 'lucide-react';
import { Button } from '@/components/ui';

interface EmptyWorkspaceStateProps {
  onCreateCompany: () => void;
}

export function EmptyWorkspaceState({ onCreateCompany }: EmptyWorkspaceStateProps) {
  return (
    <div className="min-h-[calc(100vh-200px)] flex items-center justify-center p-6">
      <div className="max-w-2xl w-full text-center">
        {/* Icon Container */}
        <div className="mb-8 inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-primary-100 to-purple-100 shadow-lg">
          <Building2 className="w-12 h-12 text-primary-600" />
        </div>

        {/* Main Heading */}
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Welcome to Axelio
        </h1>

        {/* Subheading */}
        <p className="text-xl text-gray-600 mb-8 max-w-xl mx-auto">
          You don't have access to any workspaces yet.
        </p>

        {/* Info Card */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8 max-w-xl mx-auto">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <Mail className="w-6 h-6 text-blue-600 mt-1" />
            </div>
            <div className="text-left">
              <h3 className="text-lg font-semibold text-blue-900 mb-2">
                Invited by an employer?
              </h3>
              <p className="text-blue-800 text-sm leading-relaxed">
                Please check your email for an invitation link. Once you accept the invitation,
                you'll have access to your company's workspace.
              </p>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="flex items-center gap-4 mb-8 max-w-md mx-auto">
          <div className="flex-1 h-px bg-gray-300"></div>
          <span className="text-sm font-medium text-gray-500 uppercase tracking-wider">Or</span>
          <div className="flex-1 h-px bg-gray-300"></div>
        </div>

        {/* CTA Button */}
        <div className="space-y-4">
          <Button
            onClick={onCreateCompany}
            variant="primary"
            className="px-8 py-4 text-lg font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
          >
            <Building2 className="w-5 h-5 mr-2" />
            Are you a business owner? Create your Company
          </Button>
          
          <p className="text-sm text-gray-500 mt-4">
            Set up your organization and start inviting team members
          </p>
        </div>
      </div>
    </div>
  );
}
